import React from 'react';
import styled from 'styled-components';

// Styled components
const CustomText = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.color || 'black'};
  font-size: ${props => props.size || '10px'};
  text-align: center;
  margin: -8px 0 2px 0; 
  font-family: 'Open Sans', sans-serif;
  opacity: ${props => props.opacity || 1};
`;

const Icon = styled.img`
  width: 9px;
  height: 9px;
  margin-right: 2px;
  margin-left: 15px;
`;

const Text = styled.span`
  display: inline;
`;

// DisabledInfoMessage component
const DisabledInfoMessage = ({ isVisible, message, iconSrc, style, opacity  }) => {
  if (!isVisible) return null;

  return (
    <CustomText style={style} color="black" size="10px" opacity={opacity}>
      <Icon src={iconSrc} alt="info icon" />
      <Text>{message}</Text>
    </CustomText>
  );
};

export default DisabledInfoMessage;
